import { mobileVhFix } from './utils/mobile-vh-fix';
import { initAccordion } from './modules/accordion/init-accordion';
import { initCustomSelect } from './modules/custom-select/init-custom-select';
import { initHeader } from './modules/header/init-header';
import { initModals } from './modules/modal/init-modals';
import { initTabs } from './modules/tabs/init-tabs';
import { initOpenLanguageSelection } from './modules/init-open-language-selection';
import { initChooseLanguage } from './modules/init-choose-language';
import { initOpenSearch } from './modules/init-open-search';
import { initSwiperNews } from './modules/swipers/init-swiper-news';
import { initSwiperStagesDsp } from './modules/swipers/init-swiper-stages-dsp';
import { initSwiperStagesLdsp } from './modules/swipers/init-swiper-stages-ldsp';
import { initSwiperIntro } from './modules/swipers/init-swiper-intro';
import { initEmbosingTypes } from './modules/init-embosing-types';
import { initSwiperNewsArticle } from './modules/swipers/init-swiper-news-article';
import { registerGSAPPlugins } from './modules/animations/scrollTrigger';
import { animateCatalog } from './modules/animations/catalog-animation';
import { animateAboutProduction } from './modules/animations/about-production-animation';
import { animateAboutCompany } from './modules/animations/about-company-animation';
import { animateNewsShort } from './modules/animations/news-short-animation';
import { animateFooter } from './modules/animations/footer-animation';
import { animateAboutPageBlock } from './modules/animations/about-company-page-block-animation';
import { animateHistory } from './modules/animations/history-animation';
import { animateTimeline } from './modules/animations/timeline-history-animation';
import { initSwiperItem } from './modules/swipers/init-swiper-item';
import { initSwiperOtherFormats } from './modules/swipers/init-swiper-other-formats';
import { initSwiperViewedItems } from './modules/swipers/init-swiper-viewed-items';
import { initCookie } from './modules/cookie/init-cookie';
import { openFilterHandler } from './modules/filters/open-filter-handler';
import { priceFiterHandler } from './modules/filters/price-filter-handler';
import { thicknessFilterHandler } from './modules/filters/thickness-filter-handler';
import { formatFilterHandler } from './modules/filters/format-filter-handler';
import { embossingFilterHandler } from './modules/filters/embossing-filter-handler';
import { initShowMore } from './modules/show-more/init-show-more';
import { initValidation } from './modules/validation/init-validate';
import { initFeedback } from './modules/feedback/init-feedback';
import { initShowMoreArticle } from './modules/show-more-article/init-show-more-article';
import { initDealers } from './modules/dealers/init-dealers';
import { resetFilterHandler } from './modules/filters/reset-filter-handler';

window.addEventListener('DOMContentLoaded', () => {
  // Utils
  // ---------------------------------

  mobileVhFix();

  // Modules
  // ---------------------------------

  initHeader();
  initModals();
  initAccordion();
  initTabs();
  initOpenLanguageSelection();
  initChooseLanguage();
  initOpenSearch();
  initSwiperIntro();
  initEmbosingTypes();
  initSwiperNewsArticle();
  registerGSAPPlugins();
  animateCatalog();
  animateAboutProduction();
  animateAboutCompany();
  animateNewsShort();
  animateFooter();
  animateAboutPageBlock();
  animateHistory();
  animateTimeline();
  initSwiperItem();
  initSwiperOtherFormats();
  initSwiperViewedItems();
  initCookie();
  initShowMore();
  initValidation();
  initFeedback();
  initShowMoreArticle();
  initDealers();
  openFilterHandler();
  priceFiterHandler();
  thicknessFilterHandler();
  formatFilterHandler();
  embossingFilterHandler();
  resetFilterHandler();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initCustomSelect();
    initSwiperNews();
    initSwiperStagesDsp();
    initSwiperStagesLdsp();
  });
});

// ---------------------------------

// ❗❗❗ обязательно установите плагины eslint, stylelint, editorconfig в редактор кода.

// привязывайте js не на классы, а на дата атрибуты (data-validate)

// вместо модификаторов .block--active используем утилитарные классы
// .is-active || .is-open || .is-invalid и прочие (обязателен нейминг в два слова)
// .select.select--opened ❌ ---> [data-select].is-open ✅

// выносим все в дата атрибуты
// url до иконок пинов карты, настройки автопрокрутки слайдера, url к json и т.д.

// для адаптивного JS используейтся matchMedia и addListener
// const breakpoint = window.matchMedia(`(min-width:1024px)`);
// const breakpointChecker = () => {
//   if (breakpoint.matches) {
//   } else {
//   }
// };
// breakpoint.addListener(breakpointChecker);
// breakpointChecker();

// используйте .closest(el)
